 import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import HomeView from '../views/dashboard/HomeView.vue'
import UserLogin from '../views/login/UserLogin.vue'
import FormularioRegistrarse from '../views/login/FormularioRegistrarse .vue'
import EditUser from '../views/administracion/EditUser.vue'
import AgregarUsuario from '../views/administracion/AgregarUsuario.vue'
import PublicMenu from '../views/menu/PublicMenu.vue'
import MenuAdmin from '../views/menu/MenuAdmin.vue'
import RecipeBrowser from '../views/menu/RecipeBrowser.vue'
import WalletView from '../views/wallet/WalletView.vue'
import LoyaltySettings from '../views/configuracion/LoyaltySettings.vue'
import TicketClaimView from '../views/loyalty/TicketClaimView.vue'

const DEFAULT_TITLE = 'Afrogato'

const routes = [
  {
    path: '/',
    redirect: '/menu'
  },
  {
    path: '/menu',
    name: 'MenuPublico',
    component: PublicMenu,
    meta: { title: 'Menu digital | Afrogato' }
  },
  {
    path: '/promomenu',
    name: 'PromoMenu',
    component: () => import('@/views/menu/PromoMenu.vue'),
    meta: { title: 'Promociones | Afrogato', displayMode: true, promoDisplay: 'promomenu' }
  },
  {
    path: '/promocafe',
    name: 'PromoCafe',
    component: () => import('@/views/menu/PromoMenu.vue'),
    meta: { title: 'PromoCafé | Afrogato', displayMode: true, promoDisplay: 'promocafe' }
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin,
    meta: { title: 'Iniciar sesión | Afrogato' }
  },
  {
    path: '/registrarse/:clave?',
    name: 'FormularioRegistrarse',
    component: FormularioRegistrarse,
    props: route => ({ claveProp: route.params.clave }),
    meta: { title: 'Registrarse | Afrogato' }
  },
  {
    path: '/puntos/ticket/:ticketUuid',
    name: 'TicketClaim',
    component: TicketClaimView,
    props: true,
    meta: { title: 'Reclamar puntos | Afrogato' }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: WalletView,
    meta: {
      title: 'Wallet | Afrogato',
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    name: 'UserDashboard',
    component: HomeView,
    meta: {
      title: 'Dashboard | Afrogato',
      requiresAuth: true
    }
  },
  {
    path: '/catalogo',
    name: 'MenuAdmin',
    component: MenuAdmin,
    meta: {
      title: 'Catálogo | Afrogato',
      requiresAuth: true,
      roles: ['administrador', 'superadministrador']
    }
  },
  {
    path: '/catalogo/promociones',
    name: 'PromoAdmin',
    component: () => import('@/views/menu/PromoAdmin.vue'),
    meta: { title: 'Promociones animadas | Afrogato', promoDisplay: 'promomenu', requiresAuth: true, roles: ['administrador', 'superadministrador'] }
  },
  {
    path: '/catalogo/promocafe',
    name: 'PromoCafeAdmin',
    component: () => import('@/views/menu/PromoAdmin.vue'),
    meta: { title: 'PromoCafé | Afrogato', promoDisplay: 'promocafe', requiresAuth: true, roles: ['administrador', 'superadministrador'] }
  },
  {
    path: '/catalogo/anuncio',
    name: 'MenuAnnouncementAdmin',
    component: () => import('@/views/menu/MenuAnnouncementAdmin.vue'),
    meta: { title: 'Anuncio del menú | Afrogato', requiresAuth: true, roles: ['administrador', 'superadministrador'] }
  },
  {
    path: '/configuracion/lealtad',
    name: 'LoyaltySettings',
    component: LoyaltySettings,
    meta: {
      title: 'Lealtad | Afrogato',
      requiresAuth: true,
      roles: ['administrador', 'superadministrador']
    }
  },
  {
    path: '/recetas',
    name: 'RecipeBrowser',
    component: RecipeBrowser,
    meta: {
      title: 'Recetas | Afrogato',
      requiresAuth: true,
      roles: ['administrador', 'superadministrador']
    }
  },
  {
    path: '/dashboard/user/edit/:token',
    name: 'EditUser',
    component: EditUser,
    props: true,
    meta: {
      title: 'Editar usuario | Afrogato',
      requiresAuth: true
    }
  },
  {
    path: '/dashboard/usuarios/agregar-usuario',
    name: 'AgregarUsuario',
    component: AgregarUsuario,
    props: true,
    meta: {
      title: 'Agregar usuario | Afrogato',
      requiresAuth: true
    }
  },
  {
    path: '/usuarios',
    name: 'Usuarios',
    component: () => import('@/views/Usuarios/UsersPage.vue'),
    meta: {
      title: 'Usuarios | Afrogato',
      requiresAuth: true,
      roles: ['superadministrador', 'administrador']
    }
  },
  {
    path: '/prohibido',
    name: 'Prohibido',
    component: () => import('../views/VistaProhibida.vue'),
    meta: { title: 'Acceso prohibido | Afrogato' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/menu'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const roleHierarchy = {
  usuario: 1,
  administradorevento: 2,
  administrador: 3,
  superadministrador: 4
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const user = store.state.user

  if (requiresAuth && (!user || !user.token)) return next('/login')

  const requiredRoles = to.meta && to.meta.roles
  if (!requiredRoles || !requiredRoles.length) return next()

  if (!store.state.roleLoaded) {
    try {
      await store.dispatch('fetchRole')
    } catch (error) {
      // no role means no permission
    }
  }

  const currentRole = store.state.role
  const currentLevel = roleHierarchy[currentRole] || 0
  const allowed = requiredRoles.some(role => currentLevel >= (roleHierarchy[role] || 999))

  if (!allowed) return next('/prohibido')
  return next()
})

const originalManifest = document.querySelector('link[rel="manifest"]')?.getAttribute('href') || '/manifest.json'
router.afterEach((to) => {
  const manifest = document.querySelector('link[rel="manifest"]')
  if (manifest) manifest.setAttribute('href', to.meta.displayMode ? `/${to.meta.promoDisplay || 'promomenu'}-manifest.json` : originalManifest)
  const nearestRouteWithTitle = [...to.matched]
    .reverse()
    .find(route => route.meta && route.meta.title)

  document.title = nearestRouteWithTitle
    ? nearestRouteWithTitle.meta.title
    : DEFAULT_TITLE
})

export default router
